import { actionTypes } from "./actions";

const initialState = {
  data: [],
  productsGroupEdit: {
    ProductGroupCode: "",
    ProductGroupDescription: "",
    ProductGroupActiveFrom: "",
    ProductGroupActiveTo: "",
  },
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.SET_PRODUCTS_GROUP:
      return {
        ...state,
        data: payload,
      };
    case actionTypes.SET_PRODUCTS_GROUP_ID:
      return {
        ...state,
        productsGroupEdit: payload,
      };

    case actionTypes.EDIT_FORM_CHANGE:
      return {
        ...state,

        productsGroupEdit: {
          ...state.productsGroupEdit,
          [payload.name]: payload.value,
        },
      };

    case actionTypes.SET_UPDATED_PRODUCT_GROUP:
      return {
        ...state,
        productsGroupEdit: payload,
      };

    case actionTypes.SET_FILTERED_RESULTS:
      return {
        ...state,
        data: payload,
      };

    default:
      return {
        ...state,
      };
  }
};
